'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.daysAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/daysAfter.js
// module id = 328
// module chunks = 1